var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatBubbleLeftIcon, UserMinusIcon, UserPlusIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { useNavigate } from "react-router-dom";
import { WPQTIconButton } from "../../../../../components/common/Button/Button";
import { UPDATE_USER_PAGE_TASK_DATA } from "../../../../constants";
import { useTaskActions } from "../../../../hooks/actions/useTaskActions";
import { UserPageAppContext } from "../../../../providers/UserPageAppContextProvider";
import { UserPageTaskContext } from "../../../../providers/UserPageTaskContextProvider";
function TaskControls({ task }) {
    const { state: { pageHash, userId }, } = useContext(UserPageAppContext);
    const { userTaskDispatch } = useContext(UserPageTaskContext);
    const { assignToTask, unAssignFromTask } = useTaskActions();
    const navigate = useNavigate();
    const isAssignedToTask = task === null || task === void 0 ? void 0 : task.assigned_users.some((user) => user.id === userId);
    if (task === null) {
        return null;
    }
    const onAssignToTask = () => __awaiter(this, void 0, void 0, function* () {
        yield assignToTask(pageHash, task.task_hash, (data) => {
            userTaskDispatch({ type: UPDATE_USER_PAGE_TASK_DATA, payload: data });
        });
    });
    const onUnassignFromTask = () => __awaiter(this, void 0, void 0, function* () {
        yield unAssignFromTask(pageHash, task.task_hash, () => {
            navigate(`/`);
        });
    });
    return (_jsxs("div", { className: "wpqt-mt-5 wpqt-flex wpqt-flex-wrap wpqt-justify-center wpqt-gap-4", children: [isAssignedToTask && (_jsx(WPQTIconButton, { icon: _jsx(UserMinusIcon, { className: "wpqt-icon-red wpqt-size-5" }), text: "Unassign from task", onClick: onUnassignFromTask })), isAssignedToTask && (_jsx(WPQTIconButton, { icon: _jsx(ChatBubbleLeftIcon, { className: "wpqt-icon-blue wpqt-size-5" }), text: "Manage task comments", onClick: () => {
                    navigate(`/tasks/${task.task_hash}/comments`);
                } })), !isAssignedToTask && (_jsx(WPQTIconButton, { icon: _jsx(UserPlusIcon, { className: "wpqt-icon-green wpqt-size-5" }), text: "Assing to task", onClick: onAssignToTask }))] }));
}
export { TaskControls };
